import { useEffect, useState } from 'react';

import { callHoldNameFor, isCallHeld } from '@/app/callHold/callHold';
import { useMeetingData } from '@/app/queries/MeetingQuery/context';

export default function useIsCallOpenElsewhere(isWatched: boolean) {
  const name = callHoldNameFor(useMeetingData());
  const [isOpenElsewhere, setIsOpenElsewhere] = useState(false);

  useEffect(function lookForTheCallInOtherTabs() {
    if (!isWatched) {
      return undefined;
    }

    let isCurrent = true;
    const look = () => {
      if (document.visibilityState !== 'visible') {
        return;
      }
      isCallHeld(name).then((isHeld) => {
        if (isCurrent) {
          setIsOpenElsewhere(isHeld);
        }
      });
    };

    look();
    document.addEventListener('visibilitychange', look);

    return () => {
      isCurrent = false;
      document.removeEventListener('visibilitychange', look);
    };
  }, [isWatched, name]);

  return [isOpenElsewhere, setIsOpenElsewhere] as const;
}
